// extracted by mini-css-extract-plugin
module.exports = {"LightboxWrapper":"Lightbox_LightboxWrapper__27IrC"};